import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const unarchiveEmployee = async (uuid: string) => {
  const response = await CustomAxios.post(`employees/${uuid}/unarchive`);
  return response.data;
};

interface UseUnarchiveEmployeeProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUnarchiveEmployee({ uuid, onSuccessCallback }: UseUnarchiveEmployeeProps) {
  return useMutation({
    mutationFn: () => unarchiveEmployee(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to unarchive the employee. Please try again and contact support if the problem persists.');
      }
    },
  });
}
